import React from 'react';
import c from '../w.js';

const IconDocumentFilled = React.memo(
  c(
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 5C4 3.34315 5.34315 2 7 2H12.1716C12.9672 2 13.7303 2.31607 14.2929 2.87868L19.1213 7.70711C19.6839 8.26972 20 9.03278 20 9.82843V19C20 20.6569 18.6569 22 17 22H7C5.34315 22 4 20.6569 4 19V5ZM13 9H17L13 5V9ZM16 12H8V14H16V12ZM8 16H16V18H8V16Z"
      }
    )
  )
);

export { IconDocumentFilled };
